module.exports = __webpack_public_path__ + "img/yes.ee27170e.png";